import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NoteEditorForm = styled.form`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 576px) {
    padding: 0;
  }

  @media (max-width: 400px) {
    padding: 0;
  }
`;

export const NoteFormGroup = styled.div`
  margin-bottom: 0;

  @media (max-width: 576px) {
    margin-bottom: 1rem;
  }
`;

export const NoteLabel = styled.label`
  display: flex;
  align-items: center;
  gap: clamp(0.35rem, 1.5vw, 0.5rem);
  font-family: 'Poppins', sans-serif;
  font-size: clamp(0.8rem, 2.5vw, 0.95rem);
  font-weight: 600;
  color: #1A2E40;
  margin-bottom: clamp(0.4rem, 1.5vw, 0.6rem);
  flex-wrap: wrap;
  line-height: 1.3;

  @media (max-width: 576px) {
    font-size: 0.9rem;
    gap: 0.4rem;
    margin-bottom: 0.5rem;
  }

  @media (max-width: 400px) {
    font-size: 0.85rem;
    gap: 0.35rem;
    margin-bottom: 0.4rem;
  }
`;

export const NoteLabelIcon = styled(FontAwesomeIcon)`
  color: #FFC107;
  font-size: clamp(0.9rem, 3vw, 1.1rem);
  flex-shrink: 0;

  @media (max-width: 576px) {
    font-size: 1rem;
  }

  @media (max-width: 400px) {
    font-size: 0.9rem;
  }
`;

export const NoteLabelText = styled.span`
  word-break: break-word;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const NoteTextarea = styled.textarea`
  width: 100%;
  padding: clamp(0.7rem, 2.5vw, 1rem);
  border: 2px solid ${props => props.$isFocused ? '#FFC107' : '#e5e7eb'};
  border-radius: clamp(8px, 2vw, 10px);
  font-size: clamp(0.85rem, 2.2vw, 0.95rem);
  font-family: 'Roboto', sans-serif;
  resize: vertical;
  min-height: clamp(128px, 22vh, 180px);
  max-height: min(48dvh, 360px);
  line-height: 1.5;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  touch-action: manipulation;

  @media (max-width: 576px) {
    padding: 0.75rem;
    border-radius: 8px;
    font-size: 16px;
    min-height: 128px;
    max-height: min(42dvh, 300px);
  }

  @media (max-width: 400px) {
    padding: 0.65rem;
    border-radius: 6px;
    font-size: 16px;
    min-height: 116px;
    max-height: min(36dvh, 240px);
  }

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #FFC107;
    box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
  }
`;

export const NoteCharCount = styled.small`
  color: ${props => props.$isNearLimit ? '#dc3545' : '#6c757d'};
  font-size: clamp(0.7rem, 2vw, 0.8rem);
  margin-top: clamp(0.25rem, 1vw, 0.35rem);
  display: block;
  text-align: right;
  font-weight: ${props => props.$isNearLimit ? 600 : 400};

  @media (max-width: 576px) {
    font-size: 0.75rem;
    margin-top: 0.3rem;
  }

  @media (max-width: 400px) {
    font-size: 0.7rem;
    margin-top: 0.25rem;
  }
`;
